export const buttonPrimary =
  'py-[12px] text-white bg-button hover:bg-button-hover active:bg-button-pressed cursor-pointer rounded text-center text-base border-none no-underline'

export const buttonSecondary =
  'py-[12px] text-dark active:text-dark hover:text-dark hover:bg-gray active:bg-gray cursor-pointer rounded text-center text-base border-solid border-[1px] border-cool-gray-500 active:border-cool-gray-100 hover:border-cool-gray-100 no-underline'

export const buttonSecondarySpecial =
  'py-[12px] text-dark active:text-dark hover:text-dark hover:bg-gray active:bg-gray cursor-pointer rounded text-center text-base no-underline'
